import { Avatar, Badge, Box, Button, Divider, Drawer, InputAdornment, List, ListItem, ListItemButton, ListItemIcon, ListItemText, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Menu } from '@mui/icons-material';
import * as S  from './Styled';
import Login from '../Login/Login';
import Search from '../Modal/Search/Search';
import { Search as SearchIcon } from '@mui/icons-material';
import { LOGO_HOTAREA, IMAGES_URL } from '../../constants/urls';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import StoreIcon from '@mui/icons-material/Store';
import CategoryIcon from '@mui/icons-material/Category';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import BusinessIcon from '@mui/icons-material/Business';
import MailIcon from '@mui/icons-material/Mail';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ExitToAppIcon from '@mui/icons-material/ExitToApp'
import { useAuth } from '../../context/AuthContext';
import AvatarProfile from './AvatarProfile';
import { useLocation, useNavigate } from 'react-router-dom';
import { FlexContainer } from '../../styles/common/FlexBox';
import ModalLogin from '../Modal/Login/Login';
import SimpleMenu from './SimpleMenu';
import useUserData from '../../hooks/useUserData';
import { useMediaQuery, useTheme } from '@mui/material';
import { pagesEstacio } from '../../constants/NavBar/pagesEstacio';
import CashbackNotice from './CashbackNotice';
import useCashbackNotice from '../../hooks/useCashbackNotice';

const NavBarEstacio = ({variant = 'default', hotArea, logo}) => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  const { isAuthenticated, auth, logout } = useAuth();

    const { user, loadingUser, errorUser } = useUserData();
  const cashbackNotice = useCashbackNotice({ isAuthenticated, user, loadingUser });

  const [openMobile, setOpenMobile] = React.useState(false);
  const textColor = 'ffffff'; 
  const [openLoginModal, setOpenLoginModal] = useState(false);
  const handleOpenLoginModal = () => {
    setOpenLoginModal(true);
  };
  const handleCloseLoginModal = () => {
    setOpenLoginModal(false);
  };
  const toggleDrawer = (newOpen) => () => {
    setOpenMobile(newOpen);
  };

  useEffect(() => {
    if (hotArea?.incentive_id) {
      auth(+hotArea.incentive_id);
    }

  }, [hotArea]);


  
  const DrawerList = (
    <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
      <List>
        {['Home', 'Top Descontos', 'Categorias', 'Top Lojas'].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton>
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {['Devolve', 'Blog', 'Top Cashback'].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton>
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
  const [searchValue, setSearchValue] = React.useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const goToPix = cashbackNotice === 'pix' ? () => navigate('/perfil') : undefined;

  const handleSearch = (event) => {
    if (event.key === 'Enter') {
      const queryParams = new URLSearchParams(location.search);
  
      searchValue
        ? queryParams.set('name', searchValue)
        : queryParams.delete('name');
  
      navigate({
        pathname: location.pathname,
        search: queryParams.toString(),
      });
    }
  };  
  if (variant === 'simple') {
    return (
      <Box
        sx={{
          backgroundColor: '#102051',
          padding: '10px 20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-around',
          gap: { xs: 1.5, sm: 0 },
        }}
      >
        <S.ANoDecoration href="https://www.meucupom.com/" target="_blank" rel="noreferrer">
          <S.Logo
            src="https://static.meucupom.com/media/2026%20-%20Updates/meu-cupom-logo.png"
            alt="logo"
            style={{ height: 40 }} 
          />
        </S.ANoDecoration>

        <TextField
          placeholder="Digite sua loja aqui!"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          onKeyPress={handleSearch}
          sx={{
            display: { xs: 'none', md: 'block' },
            backgroundColor: 'white',
            borderRadius: '10px',
            '& .MuiOutlinedInput-root': {
              borderRadius: '10px',
            },
            '& .MuiInputBase-input': {
              padding: '10px',
              width: { xs: '100%', sm: '498px' },
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: 'gray', fontSize: 24 }} />
              </InputAdornment>
            ),
          }}
        />
          <Button sx={{ color: 'white',  background:'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)', padding: '10px 20px' }} onClick={handleOpenLoginModal}>Faça Login</Button>
          <SimpleMenu/>
        <ModalLogin open={openLoginModal} handleClose={handleCloseLoginModal} />
      </Box>
    );
  } 
  return (
    <div>
      <S.NavBarContainerDesktop backgroundColor='#f1f1f1' color='#363636' isPro>
        <S.ANoDecoration href="https://www.meucupom.com/" target='_blank' rel='noreferrer'>
          <S.Logo src="https://static.meucupom.com/media/2026%20-%20Updates/meu-cupom-logo.png" alt="logo" />
        </S.ANoDecoration>
        <img style={{width: '7rem'}} src={`${LOGO_HOTAREA}${hotArea.imageName}`}  alt="" />

        <TextField
        id="outlined-start-adornment"
        sx={{
            display: { xs: 'block', sm: 'none', md: 'none', lg: 'block' },
            m: 1,
            width: '40ch',

            '& .MuiOutlinedInput-root': {
            borderRadius: '999px', // bem arredondado
            background: 'linear-gradient(90deg, #dcdcdc 0%, #ffffff 100%)',
            color: '#363636',

            '& fieldset': {
                borderColor: '#363636',
            },

            '&:hover fieldset': {
                borderColor: '#363636',
            },

            '&.Mui-focused fieldset': {
                borderColor: '#363636',
            },
            },

            '& .MuiInputBase-input': {
            color: '#363636',
            height: '1em',
            padding: '12px 14px', // deixa o input mais “gordinho”
            },
        }}
        InputProps={{
            startAdornment: (
            <InputAdornment
                position="start"
                sx={{
                color: '#363636',
                '& svg': {
                    color: '#363636',
                },
                }}
            >
                <Search />
            </InputAdornment>
            ),
        }}
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        onKeyPress={handleSearch}
        />

        <FlexContainer>
          {pagesEstacio.map((page) => (
            <S.ANoDecoration key={page.nome} href={page.url} target='_blank'>
              <Button
                sx={{ my: 2, color: '#363636', display: 'block' }}
              >
                {page.nome}
              </Button>
            </S.ANoDecoration>
              
            ))}
        </FlexContainer>
        <Box sx={{ position: 'relative' }}>
        {isAuthenticated ? (
          <AvatarProfile user={user} logout={logout} />
        ) : (
          <>
            {hotArea?.type === 'LOYALTY' && (
              <Login 
                name="Entrar" 
                color={`#363636`}
                border={`1px solid #363636`} 
                hotAreaName={hotArea.name} 
                longDescription={hotArea.longDescription}
                logo={`${LOGO_HOTAREA}${hotArea.imageName}`} 
                incentiveId={hotArea.incentive_id}
                slug={hotArea.slug}
              />
            )}
            {(hotArea?.type === 'REGULAR' || hotArea?.type === undefined) && (
              <>
                <Button sx={{ color: 'white', border: `1px solid #${textColor}`, padding: "6px 20px" }}
                        onClick={handleOpenLoginModal}>
                    Login
                </Button>
                <ModalLogin open={openLoginModal} handleClose={handleCloseLoginModal} />
              </>
            )}
          </>
        )}
        <CashbackNotice type={cashbackNotice} placement="below" onClick={goToPix} />
        </Box>

      </S.NavBarContainerDesktop>

      <S.NavBarContaineMobileEstacio style={{backgroundColor: '#f1f1f1 !important'}} isPro>
        <Badge color="warning" variant="dot" invisible={!cashbackNotice}>
          <Menu sx={{ color: '#363636' }} onClick={toggleDrawer(true)}/>
        </Badge>
        <Drawer open={openMobile} onClose={toggleDrawer(false)}>
          <S.LoginMobile>
            <S.LoginMobilePerfil>
                <Avatar src={user?.google_image} sx={{width: 72, height: 72,}}>
                  {!user?.google_image && (user?.email ? user.email[0].toUpperCase() : 'U')}
                </Avatar>
                {isAuthenticated ? (
                <FlexContainer direction="column" align="center" gap={1}>
                  <span style={{ fontWeight: 'bold', fontSize: '1.2rem', color: 'white', margin: '10px 0px'}}>{user?.name || 'Usuário'}</span>
                </FlexContainer>
              ) : (
                <>
                    {hotArea?.type === "LOYALTY" && (
                      <Login
                        name="Entrar"
                        color={`#${textColor}`}
                        border={`1px solid #${textColor}`}
                        hotAreaName={hotArea.name}
                        longDescription={hotArea.longDescription}
                        logo={`${LOGO_HOTAREA}${hotArea.imageName}`}
                        onClick={handleOpenLoginModal} 
                        incentiveId={hotArea.incentive_id}
                        slug={hotArea.slug}
                      />
                    )}
                    {(hotArea?.type === "REGULAR" || hotArea?.type === undefined) && (
                      <>
                        <Button
                          sx={{ color: "white", border: `1px solid #${textColor}`, padding: "6px 20px" }}
                          onClick={handleOpenLoginModal}
                        >
                          Login
                        </Button>
                        <ModalLogin open={openLoginModal} handleClose={handleCloseLoginModal} />
                      </>
                    )}
                </>
              )}
              <CashbackNotice
                type={cashbackNotice}
                placement="inline"
                onClick={goToPix && (() => { setOpenMobile(false); goToPix(); })}
              />
            </S.LoginMobilePerfil>
          
          {/* <S.LoginMobileButton>
            </S.LoginMobileButton> */}
            {/* <FlexContainer justify="center" align="center" direction="row">
              <S.BoxIcon borderColor="#102051">
                <CrownIcon color="#102051"/>
              </S.BoxIcon>
              <S.BoxIcon borderColor="#f4cd05">
                <StarIcon sx={{color: '#f4cd05'}}/>
              </S.BoxIcon>
              <S.BoxIcon borderColor="red">
                  <FavoriteIcon sx={{color: 'red'}}/>
              </S.BoxIcon>
            </FlexContainer> */}
          </S.LoginMobile>
          {/* DrawerList só com Home */}
        <Box
        sx={{
            width: 250,

            '& .MuiListItemButton-root': {
            color: '#363636',
            },

            '& .MuiListItemIcon-root': {
            color: '#363636',
            minWidth: 40,
            },

            '& .MuiTypography-root': {
            color: '#363636', // 🔥 AQUI resolve de vez
            },
        }}
        role="presentation"
        onClick={toggleDrawer(false)}
        >

        <List>
            {isAuthenticated && (
            <>
                <ListItem disablePadding>
                <ListItemButton onClick={() => navigate('/perfil')}>
                    <ListItemIcon>
                    <AccountCircleIcon />
                    </ListItemIcon>
                    <ListItemText primary="Meu Perfil" />
                </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                <ListItemButton onClick={() => navigate('/perfil/devolve')}>
                    <ListItemIcon>
                    <CurrencyExchangeIcon />
                    </ListItemIcon>
                    <ListItemText primary="Meu Cupom Devolve" />
                </ListItemButton>
                </ListItem>
            </>
            )}

            <ListItem disablePadding>
            <ListItemButton onClick={() => navigate('/')}>
                <ListItemIcon>
                <InboxIcon />
                </ListItemIcon>
                <ListItemText primary="Home" />
            </ListItemButton>
            </ListItem>

            {/* <ListItem disablePadding>
            <ListItemButton onClick={() => navigate('/lojas')}>
                <ListItemIcon>
                <StoreIcon />
                </ListItemIcon>
                <ListItemText primary="Lojas" />
            </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
            <ListItemButton onClick={() => navigate('/categorias')}>
                <ListItemIcon>
                <CategoryIcon />
                </ListItemIcon>
                <ListItemText primary="Categorias" />
            </ListItemButton>
            </ListItem> */}

            <ListItem disablePadding>
            <ListItemButton  onClick={() => navigate('/ajuda/perguntas-frequentes?utm_source=clube-do-aluno')}>
                <ListItemIcon>
                <HelpOutlineIcon />
                </ListItemIcon>
                <ListItemText primary="Ajuda" />
            </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
            <ListItemButton onClick={() => navigate('/institucional/contato')}>
                <ListItemIcon>
                <BusinessIcon />
                </ListItemIcon>
                <ListItemText primary="Fale Conosco" />
            </ListItemButton>
            </ListItem>

            {isAuthenticated && (
            <List sx={{ marginTop: 'auto' }}>
                <ListItem disablePadding>
                <ListItemButton onClick={logout}>
                    <ListItemIcon>
                    <ExitToAppIcon />
                    </ListItemIcon>
                    <ListItemText primary="Logout" />
                </ListItemButton>
                </ListItem>
            </List>
            )}
        </List>
        </Box>

        </Drawer>

        <img style={{width: '4rem'}} src={`${LOGO_HOTAREA}${hotArea.imageName}`} alt="" />
        <S.ANoDecoration href="https://www.meucupom.com/" target='_blank' rel='noreferrer'>
          <S.Logo src="https://static.meucupom.com/media/2026%20-%20Updates/meu-cupom-logo.png" alt="logo" />
        </S.ANoDecoration>

        
        
        <Search searchValue={searchValue} setSearchValue={setSearchValue} customColor={'#363636'}/>
        
      </S.NavBarContaineMobileEstacio>

    </div>
    
          
  )
}

export default NavBarEstacio